<template>
    <div>
        <div>
            <b-nav tabs>
                <b-nav-item router-link to="/shipping-fee">
                    <icon name="money-bill-alt"></icon>
                    ค่าเที่ยว
                </b-nav-item>&nbsp
                <b-nav-item router-link to="/transport-fee">
                    <icon name="money-bill-alt"></icon>
                    ค่าขนส่ง
                </b-nav-item>&nbsp
                <b-nav-item router-link to="/edit-shipping">
                    <icon name="edit"></icon>
                    บันทึกการแก้ไขค่าเที่ยว
                </b-nav-item>
            </b-nav>
        </div>
        <div class="container-fluid" style="background-color: white">
            <router-view />
        </div>
    </div>
</template>

<script>
    export default {
        name: "shipping-layout"
    }
</script>

<style scoped>

</style>
